<script>
  import { createEventDispatcher, onMount } from 'svelte';

  import { InlineNotification, Modal, DataTable } from 'carbon-components-svelte';

  import LoadingSpinner from '../../components/LoadingSpinner.svelte';
  import { addUsersToGroup, getAllUsers } from '../../services';
  import { asOptionalTextColumn } from '../../utils';

  export let organizationId;
  export let groupId;
  export let open = false;
  export let existingGroupUsers = [];

  let resultNotification;
  let loading = false;
  let allUsers = [];
  let selectedRowIds;

  const dispatch = createEventDispatcher();

  onMount(async () => {
    try {
      allUsers = await getAllUsers();
    } catch (e) {
      console.error('[AddUsersToGroupModal] Failed to retrieve users!', e);
    }
  });

  $: users = allUsers.filter(({ organizationId: userOrganizationId, id }) => {
    return organizationId === userOrganizationId && !existingGroupUsers.find((user) => user.id === id);
  });

  async function onModalSubmit() {
    if (!selectedRowIds.length) {
      dispatch('close');
      return;
    }
    resultNotification = null;
    loading = true;
    try {
      await addUsersToGroup(selectedRowIds, groupId);

      loading = false;
      dispatch('submit');
      dispatch('close');
    } catch (error) {
      console.error('[AddUsersToGroupModal] Failed to add users to group!', error);

      const errorMessage = error?.response?.data?.message ?? 'Verify your submission and try again!';
      resultNotification = {
        kind: 'error',
        title: 'Error:',
        subtitle: `Failed to add users to group! ${errorMessage}`,
      };
      loading = false;
    } finally {
      selectedRowIds = [];
    }
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  hasScrollingContent={true}
  modalHeading="Add Users to Group"
  preventCloseOnClickOutside={true}
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={loading || !selectedRowIds?.length}
  size="lg"
  bind:open
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit={onModalSubmit}
>
  <LoadingSpinner {loading}>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
      />
    {/if}
    {#if !users.length}
      <InlineNotification kind="warning" lowContrast hideCloseButton subtitle="No users available to add to this group." />
    {:else}
      <p class="paragraph">
        The table below lists users which belong to this group's parent organization. Select one or more users to be added to the group.
      </p>

      <DataTable
        headers={[
          { key: 'name', value: 'Name', ...asOptionalTextColumn },
          { key: 'email', value: 'Email Address' },
          { key: 'statusDescription', value: 'Status' },
        ]}
        rows={users}
        selectable
        bind:selectedRowIds
        sortable
      />
    {/if}
  </LoadingSpinner>
</Modal>

<style>
  .paragraph {
    padding-bottom: 2rem;
  }
</style>
